// A known location lets all three independent public requests start together.
export async function loadPublicBookingData(api, orgSlug, locationId) {
  const locationsRequest = api.getLocations(orgSlug).catch(() => ({ data: [] }));
  if (locationId) {
    const params = { location_id: locationId };
    const [org, locations, services] = await Promise.all([
      api.getOrg(orgSlug, params), locationsRequest, api.getServices(orgSlug, params),
    ]);
    return { org: org.data, locations: locations.data, services: services.data };
  }
  const locations = (await locationsRequest).data;
  const onlyLocation = Array.isArray(locations) && locations.length === 1 ? String(locations[0].id) : '';
  const [org, services] = await Promise.all([
    api.getOrg(orgSlug, onlyLocation ? { location_id: onlyLocation } : undefined),
    onlyLocation ? api.getServices(orgSlug, { location_id: onlyLocation }) : { data: [] },
  ]);
  return { org: org.data, locations, services: services.data };
}
